import {
  useUpdateFournisseurMutation,
  useDeleteFournisseurMutation,
} from 'actions/fournisseurs/mutations';
import { toast } from 'react-toastify';
import { useGetFournisseurQuery } from 'actions/fournisseurs/queries';

const useFournisseurData = (dossierId) => {
  const {
    data: fournisseurResponse,
    isLoading,
    isFetching,
    refetch,
  } = useGetFournisseurQuery({ dossier_id: dossierId });

  const [updateFournisseur] = useUpdateFournisseurMutation();
  const [deleteFournisseur] = useDeleteFournisseurMutation();

  const updatedFournisseurs = fournisseurResponse?.data && Array.isArray(fournisseurResponse.data)
    ? fournisseurResponse.data.map((fournisseur) => ({
        ...fournisseur,
        displayName: `${fournisseur?.nom} (${fournisseur?.id})`,
      }))
    : [];

  const handleUpdateFournisseur = async (fournisseurId, updateData) => {
    try {
      await updateFournisseur({
        id: fournisseurId,
        ...updateData,
      }).unwrap();
      // Attendre que le refetch se termine
      await refetch();
    } catch (error) {
      toast.error(`Update error: ${error.data?.error || error.message}`);
      console.error('Request failed:', error);
    }
  };

  const handleDeleteFournisseur = async (fournisseurId) => {
    try {
      await deleteFournisseur({ id: fournisseurId }).unwrap();
      toast.success('Fournisseur supprimé avec succès');
      // Attendre que le refetch se termine
      await refetch();
    } catch (error) {
      // Afficher le message d'erreur du backend s'il existe
      const errorMessage = error.data?.message || error.data?.error || error.message;
      toast.error(errorMessage);
    }
  };

  return {
    updatedFournisseurs,
    handleUpdateFournisseur,
    handleDeleteFournisseur,
    refetch,
    isLoading: isLoading || (isFetching && !fournisseurResponse),
  };
};

export default useFournisseurData;
